import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { countFreezingDays, freezingLabel, toForecastDays, type AmbientTemperatureDay } from './ambientTemperature';
import { getTemperatureUnit } from 'src/module/authentication/selector';
import { getWeatherForecast, getWeatherForecastLoading } from 'src/module/weather/selector';
import { useTranslation } from 'src/i18n';

export interface AmbientTemperatureData {
  hasForecast: boolean;
  days: AmbientTemperatureDay[];
  freezingDayCount: number;
  freezingLabel: string;
  loading: boolean;
}

export default function useAmbientTemperature (): AmbientTemperatureData {
  const { t } = useTranslation();

  const weatherForecast = useSelector(getWeatherForecast);
  const temperatureUnit = useSelector(getTemperatureUnit);
  const loading = useSelector(getWeatherForecastLoading);

  const days = useMemo(
    () => toForecastDays(weatherForecast.get('forecast'), { unit: temperatureUnit, t }),
    [weatherForecast, temperatureUnit, t]
  );

  return {
    hasForecast: Boolean(weatherForecast.get('city')) && days.length > 0,
    days,
    freezingDayCount: countFreezingDays(days),
    freezingLabel: freezingLabel(temperatureUnit),
    loading,
  };
}
